import * as React from "react";
const SvgError20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 18,
        fill: "black",
        viewBox: "0 0 20 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m15.25.908-.29-.5H5.04l-.288.5L.368 8.5l-.29.5.29.5 4.383 7.592.288.5h9.922l.288-.5L19.633 9.5l.288-.5-.288-.5L15.249.908Zm-9.056 1.5h7.612L17.612 9l-3.806 6.592H6.194L2.388 9l3.806-6.592Zm2.013 3.385L7.5 5.086 6.086 6.5l.707.707L8.586 9l-1.793 1.793-.707.707L7.5 12.914l.707-.707L10 10.414l1.793 1.793.707.707 1.414-1.414-.707-.707L11.414 9l1.793-1.793.707-.707L12.5 5.086l-.707.707L10 7.586 8.207 5.793Z",
      clipRule: "evenodd"
    })
  );
export default SvgError20Px;
